import type { OneTrustGlobals } from './models/onetrust';

const POLL_MS = 500;
const MAX_ATTEMPTS = 10;

function readOT(): OneTrustGlobals | undefined {
  if (typeof window === 'undefined') return undefined;
  return window.OneTrust;
}

export async function waitForOT(): Promise<OneTrustGlobals | undefined> {
  if (typeof window === 'undefined') return undefined;
  const existing = readOT();
  if (existing?.getGeolocationData || existing?.ToggleInfoDisplay) return existing;

  let attempts = 0;
  while (attempts < MAX_ATTEMPTS) {
    await new Promise((resolve) => setTimeout(resolve, POLL_MS));
    const ot = readOT();
    if (ot?.getGeolocationData || ot?.ToggleInfoDisplay) return ot;
    attempts++;
  }
  return undefined;
}

export async function toggleCookieBanner(): Promise<void> {
  const ot = await waitForOT();
  ot?.ToggleInfoDisplay?.();
}

export function getActiveGroups(): string[] {
  if (typeof window === 'undefined') return [];
  const raw = window.OptanonActiveGroups;
  return raw ? raw.toUpperCase().split(',').filter(Boolean) : [];
}

export function getGeo(): { country?: string; state?: string } {
  return readOT()?.getGeolocationData?.() ?? {};
}
